import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Spin } from 'antd';

import DefaultModal from '../components/DefaultModal';
import { ReactComponent as ErrorPrinterIcon } from '../components/ph_printer-light-outline.svg';

const Wrapper = styled.div`
  width: 100%;
  text-align: center;

  .title {
    font-size: 32px;
    font-weight: 700;
  }
  .error,
  .desc.error {
    color: #fa503c;
  }
  .subTitle {
    font-size: 24px;
    color: #6d7582;
  }
  .desc {
    font-size: 20px;
    color: #0067ff;
  }
  .content {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 300px;
    padding-bottom: 10px;
    font-size: 24px;
    font-weight: 700;

    svg {
      padding-bottom: 10px;
    }
    .ant-spin.ant-spin-spinning {
      scale: 3;
    }
  }
`;

interface LabelPrintingModalProps {
  open: boolean;
  close: () => void;
  printData: any[];
}

const LabelPrintingModal = ({ open, printData, close }: LabelPrintingModalProps) => {
  const [isError, setIsError] = useState<boolean>(false);

  const splitIntoChunks = (str: string, num: number) => {
    const chunks = [];
    for (let i = 0; i < str.length; i += num) {
      chunks.push(str.slice(i, i + num));
    }
    return chunks;
  };

  const viewResult = (result: string) => {
    if (!result) return;
    const status = result.split(':');

    if (status[1] !== 'success') {
      setTimeout(() => {
        setIsError(true);
      }, 3000);
    } else {
      setIsError(false);
      setTimeout(() => {
        close();
      }, 3000);
    }
  };

  const printSideLabel = async (data: any) => {
    splitIntoChunks(data.menuName, 10).forEach((text, index) => {
      const y = index === 0 ? 15 : 15 + 42 * index;
      window.drawVectorFont(text.trim(), 15, y, 'K', 38, 38, 0, 1, 0, 0, 0, 0, false);
    });
    window.drawBlock(15, 173, 125, 217, 'O', 0);
    window.drawVectorFont(data.robotName, 20, 175, 'K', 42, 42, 0, 1, 1, 0, 0, 0, false);
    window.drawDeviceFont(data.receiverName, 145, 175, 'c', 1, 1, 0, 0, 0, 0);
    window.drawDeviceFont(`(${data.payRoomIdx})`, 210, 200, 'c', 1, 1, 0, 0, 0, 0);
    window.printBuffer();
  };

  const printTopLabel = async (data: any) => {
    window.drawBlock(15, 15, 275, 58, 'O', 0);
    window.drawVectorFont(data.receiverName, 15, 17, 'K', 40, 40, 0, 1, 1, 0, 0, 0, false);
    splitIntoChunks(data.menuName, 10).forEach((text, index) => {
      const y = index === 0 ? 75 : 75 + 42 * index;
      window.drawVectorFont(text.trim(), 15, y, 'K', 38, 38, 0, 1, 0, 0, 0, 0, false);
    });
    window.printBuffer();
    printSideLabel(data);
  };

  const handleConfirmClick = () => {
    if (open && !!printData) {
      setIsError(false);
      window.localAddress = '//127.0.0.1:18080/WebPrintSDK/';
      window.setConnectionMode('http:');
      window.clearBuffer();
      window.setWidth(320);

      printData.forEach((data, index) => {
        window.setLabelId(index);
        printTopLabel(data);
      });
      const labelData = window.getLabelData();
      window.requestPrint('DX220', labelData, viewResult);
    }
  };

  useEffect(() => {
    handleConfirmClick();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, printData]);

  const cancelText = isError ? '닫기' : '출력 취소';
  return (
    <DefaultModal
      open={open}
      onCancel={close}
      onOk={handleConfirmClick}
      cancelText={cancelText}
      okText="재출력"
      isConfirm={isError}
    >
      {!isError ? (
        <Wrapper>
          <div>
            <div className="title">라벨 출력 진행 중</div>
            <div className="subTitle">라벨 출력은 &quot;주문확정&quot; 탭에서도 가능합니다</div>
          </div>
          <div className="content">
            <Spin size="large" />
          </div>
          <div className="desc">출력이 완료될 때까지 잠시만 기다려주세요</div>
        </Wrapper>
      ) : (
        <Wrapper>
          <div>
            <div className="title error">라벨 출력 실패</div>
          </div>
          <div className="content">
            <ErrorPrinterIcon />
            <div>라벨 출력기 연결 상태와 용지 확인 후</div>
            <div>재출력 버튼을 눌러주세요</div>
          </div>
          <div className="desc error">출력 도중 오류가 난 경우, 재출력 시 처음부터 다시 출력됩니다</div>
        </Wrapper>
      )}
    </DefaultModal>
  );
};

export default LabelPrintingModal;
